import { createHttpClient } from '@thehotelsnetwork/http-client';

export default createHttpClient();
